import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getBookings, removeBooking } from '../../../slice/bookingSlice';
import { Link } from 'react-router-dom';

const List = () => {
    const dispatch = useDispatch();
    const { data: bookings, loading } = useSelector((state) => state.booking);

    useEffect(() => {
        dispatch(getBookings());
    }, [dispatch]);

    console.log("Admin Bookings State:", { bookings, loading });

    const handleDelete = (id) => {
        if (window.confirm('Are you sure you want to delete this booking?')) {
            dispatch(removeBooking(id));
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Package Bookings</h4>
            </div>
            <div className="mt-4 px-4 bg-white rounded shadow-sm py-4 overflow-auto">
                {loading ? (
                    <div className="text-center py-5">Loading...</div>
                ) : (
                    <table className="table table-striped table-hover">
                        <thead className="thead-dark">
                            <tr>
                                <th>#</th>
                                <th>Client Details</th>
                                <th>Travelers</th>
                                <th>Date</th>
                                <th>City</th>
                                <th>Message</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bookings && bookings.length > 0 ? (
                                bookings.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <strong>{item.name}</strong><br/>
                                            <small className="text-muted">{item.email}</small><br/>
                                            <small className="text-muted">{item.number}</small>
                                        </td>
                                        <td>{item.travelers}</td>
                                        <td>{item.travelDate}</td>
                                        <td>{item.city}</td>
                                        <td>
                                            <div style={{ maxWidth: '200px', fontSize: '0.85rem' }}>
                                                {item.message}
                                            </div>
                                        </td>
                                        <td>
                                            <span className={`badge badge-${item.status === 'Pending' ? 'warning' : item.status === 'Confirmed' ? 'success' : 'danger'}`}>
                                                {item.status}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="btn-group">
                                                <Link 
                                                    to={`/khajuraho/bookings/update/${item.id}`} 
                                                    className="btn btn-primary btn-sm mr-2"
                                                >
                                                    Edit
                                                </Link>
                                                <button 
                                                    className="btn btn-danger btn-sm" 
                                                    onClick={() => handleDelete(item.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" className="text-center">No bookings found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default List;
